"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAladinErrorData = exports.AladinError = void 0;
class AladinError extends Error {
    constructor(data) {
        super(data.message);
        this.key = data.key;
        this.details = data.details;
    }
}
exports.AladinError = AladinError;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function isAladinErrorData(value, key) {
    if (value === null || value === undefined) {
        return false;
    }
    if (key !== undefined) {
        return value.key === key && typeof value.message === 'string';
    }
    else {
        return typeof value.key === 'string' && typeof value.message === 'string';
    }
}
exports.isAladinErrorData = isAladinErrorData;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3IuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvZXJyb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBcUJBLE1BQWEsV0FBeUMsU0FBUSxLQUFLO0lBSWpFLFlBQVksSUFBd0I7UUFDbEMsS0FBSyxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUMsQ0FBQTtRQUNuQixJQUFJLENBQUMsR0FBRyxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUE7UUFDbkIsSUFBSSxDQUFDLE9BQU8sR0FBRyxJQUFJLENBQUMsT0FBTyxDQUFBO0lBQzdCLENBQUM7Q0FDRjtBQVRELGtDQVNDO0FBRUQsaUhBQWlIO0FBQ2pILFNBQWdCLGlCQUFpQixDQUFDLEtBQVUsRUFBRSxHQUFZO0lBQ3hELElBQUksS0FBSyxLQUFLLElBQUksSUFBSSxLQUFLLEtBQUssU0FBUyxFQUFFO1FBQ3pDLE9BQU8sS0FBSyxDQUFBO0tBQ2I7SUFDRCxJQUFHLEdBQUcsS0FBSyxTQUFTLEVBQUU7UUFDcEIsT0FBTyxLQUFLLENBQUMsR0FBRyxLQUFLLEdBQUcsSUFBSSxPQUFPLEtBQUssQ0FBQyxPQUFPLEtBQUssUUFBUSxDQUFBO0tBQzlEO1NBQU07UUFDTCxPQUFPLE9BQU8sS0FBSyxDQUFDLEdBQUcsS0FBSyxRQUFRLElBQUksT0FBTyxLQUFLLENBQUMsT0FBTyxLQUFLLFFBQVEsQ0FBQTtLQUMxRTtBQUNILENBQUM7QUFURCw4Q0FTQyJ9